import React, { useState } from "react";
import ReactDOM from "react-dom";
import "./select-layout-dialog.css";
import { toast } from "react-toastify";
import { MapLayouts } from "../../../data/map-layout.enum";

export default function SelectLayoutDialog({ layout, selectedCaps, onCancel, onConfirm }) {
    // Determine grid dimensions based on layout
    const isHorizontal = layout === MapLayouts.HORIZONTAL;
    const columns = isHorizontal ? 5 : 3; // Horizontal: 5 sections, Vertical: 3 sections
    const rows = isHorizontal ? 3 : 5; // Horizontal: 3 options per section, Vertical: 5 options per section

    // Initialize state
    const [selected, setSelected] = useState(selectedCaps);

    function handleSelect(column, row) {
        const newSelection = [...selected];

        if (isHorizontal) {
            newSelection[column] = row; // Standard for horizontal layout
        } else {
            newSelection[row] = column; // Reverse row and column for vertical layout
        }

        setSelected(newSelection);
    }

    function handleConfirm() {
        if (
            selected.length !== 5 || // Ensure all sections are selected
            selected.includes(undefined) // Ensure no missing selections
        ) {
            toast.error("Choose a valid layout");
            return;
        }

        onConfirm(selected);
    }

    function handleCancel() {
        if (
            selected.length !== 5 || // Ensure all sections are selected
            selected.includes(undefined) // Ensure no missing selections
        ) {
            toast.error("Choose a valid layout");
            return;
        }

        onCancel();
    }

    function isSelectedCapsEmpty() {
        return selectedCaps?.length < 5;
    }

    function isBoxSelected(colIndex, rowIndex) {
        if (isHorizontal) {
            if (selected[colIndex] === rowIndex) {
                return "selected";
            } else {
                return "";
            }
        } else {
            if (selected[rowIndex] === colIndex) {
                return "selected";
            } else {
                return "";
            }
        }
    }

    return ReactDOM.createPortal(
        <div className="dialog-overlay" onClick={handleCancel}>
            <div id="dialog-container" onClick={(e) => e.stopPropagation()}>
                <div id="dialog-title">Choose Layout</div>
                <div id="grid-container">
                    {Array.from({ length: columns }, (_, colIndex) => (
                        <div key={colIndex} className="column">
                            {Array.from({ length: rows }, (_, rowIndex) => (
                                <div
                                    key={rowIndex}
                                    className={`grid-item ${
                                        isHorizontal
                                            ? isBoxSelected(colIndex, rowIndex)
                                            : isBoxSelected(colIndex, rowIndex)
                                    }`}
                                    onClick={() => handleSelect(colIndex, rowIndex)}
                                />
                            ))}
                        </div>
                    ))}
                </div>
                <div id="dialog-buttons">
                    {!isSelectedCapsEmpty() && <button onClick={handleCancel}>Cancel</button>}
                    <button onClick={handleConfirm}>Confirm</button>
                </div>
            </div>
        </div>,
        document.body
    );
}